<template>
    <a-space>
        <div style="flex: auto; flex-direction: row;">
            <div class="selector" v-if="player_info">
                <img class="icon" alt="default"
                    :src="player_info.player_headshot"
                     />
                <span class="member-name">
                    {{ player_partner_info ?
                    [(player_info.player_name === "-1" ? player_info.player_eng_name : player_info.player_name),
                    (player_partner_info.player_name === "-1" ? player_partner_info.player_eng_name : player_partner_info.player_name)].join(" & ")
                    : (player_info.player_name === "-1" ? player_info.player_eng_name : player_info.player_name) }}
                </span>
                <img v-if="player_partner_info" class="icon"
                     :src="player_partner_info.player_headshot"
                     alt="default" />
                <span class="medal_and_win">奖牌：</span>
                <a-select ref="select1" v-model="value1" style="width: 120px; font-size: 20px;" :options="options1"
                    @focus="focus1" @change="handleSelection"></a-select>
                <span class="medal_and_win">胜负：</span>
                <a-select ref="select2" v-model="value2" style="width: 120px; font-size: 20px;" :options="options2"
                    @focus="focus2" @change="handleSelection"></a-select>
            </div>
            <div class="tableHolder">
                <a-table :columns="columns" :data-source="displayed_data" :pagination="false" :bordered="true"
                    :rowClassName="setRowClass" :rowKey="(record) => record.key" :scroll="{ x: table_width, y: table_height-50 }">
                  <div slot="indexTitle" style="font-weight: bold; font-size: 22px; text-align: center; color: white;">{{"序号"}}</div>
                  <div slot="matchTitle" style="font-weight: bold; font-size: 22px; text-align: center; color: white;">
                        {{ "比赛" }}
                    </div>
                    <div slot="dateTitle" style="display: flex; flex-direction: row;">
                        <div style="font-weight: bold; font-size: 22px; text-align: center; color: white;">时间</div>
                        <!-- {{ "时间" }} -->
                        <div style="display: flex; flex-direction: column;">
                            <img src="@/assets/uparrow.svg" @click="dateAscending()" width="15px" height="15px"
                                style="filter: invert(100%); margin-left: 5px;" />
                            <img src="@/assets/downarrow.svg" @click="dateDescending()" width="15px" height="15px"
                                style="filter: invert(100%); margin-left: 5px;" />
                        </div>
                    </div>
                    <div slot="locationTitle" style="font-weight: bold; font-size: 22px; text-align: center; color: white;">
                        {{ "地点" }}
                    </div>
                    <div slot="medalTitle" style="display: flex; flex-direction: row;">
                        <div style="font-weight: bold; font-size: 22px; text-align: center; color: white;">名次</div>
                        <!-- {{ "名次" }} -->
                        <div style="display: flex; flex-direction: column;">
                            <img src="@/assets/uparrow.svg" @click="medalAscending()" width="15px" height="15px"
                                style="filter: invert(100%); margin-left: 5px;" />
                            <img src="@/assets/downarrow.svg" @click="medalDescending()" width="15px" height="15px"
                                style="filter: invert(100%); margin-left: 5px;" />
                        </div>
                    </div>
                    <div slot="levelTitle" style="font-weight: bold; font-size: 22px; text-align: center; color: white;">
                        {{ "比赛阶段" }}
                    </div>
                    <div slot="competitorsTitle"
                        style="font-weight: bold; font-size: 22px; text-align: center; color: white;">
                        {{ "参赛双方" }}
                    </div>
                    <!-- <div slot="overallTitle" style="font-weight: bold; font-size: 22px; text-align: center; color: white;">
                        {{ "局比分" }}
                    </div> -->
                    <div slot="gameTitle" style="font-weight: bold; font-size: 22px; text-align: center; color: white;">
                        {{ "局回合比分" }}
                    </div>
                    <div slot="index" slot-scope="_, item,index" class="table-text">
                      {{ index+1 }}
                    </div>
                    <div slot="match" slot-scope="_, item" class="table-text">
                        {{ item.match }}
                    </div>
                    <div slot="date" slot-scope="_, item" class="table-text" style="font-size: medium">
                        {{ item.date.replace(/\b(\d{2})(\d{2})-/g, '$2-') }}
<!--                      {{ item.date.replace(/\b\d{4}-/g, '') }}-->
                    </div>
                    <div slot="location" slot-scope="_, item" class="table-text">
                        {{ item.location }}
                    </div>
                    <div slot="medal" slot-scope="_, item">
                        <div :key="1" style="text-align: center;">
                            <img v-if="item.medal === 'Gold'" class="medal" src="@/assets/gold.png" />
                            <img v-else-if="item.medal === 'Silver'" class="medal" src="@/assets/silver.png" />
                            <img v-else-if="item.medal === 'Bronze'" class="medal" src="@/assets/bronze.png" />
                          <div v-else-if="item.medal === 'not-count'" class="table-text">另计</div>
                          <div v-else class="table-text">-</div>

                        </div>
                    </div>
                    <div slot="last_match_level" slot-scope="_, item" class="table-text">
                        {{ item.last_match_level }}
                    </div>
                    <div slot="competitors" slot-scope="_, item" style="display: flex; flex-direction: row;">
                        <div style="display: flex; flex-direction: column; margin-left: 40px;">
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <div>
                                    <img class="flag" :src="getCountryUrl(item.competitors[0].country)" />
                                </div>
                                <div style="font-size: 16px;">
                                    {{ item.competitors[0].name }}
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <div>
                                    <img class="flag" :src="getCountryUrl(item.competitors[1].country)" />
                                </div>
                                <div style="font-size: 16px;">
                                    {{ item.competitors[1].name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div slot="overall" slot-scope="_, item" style="display: flex; flex-direction: column;">
                        <div class="total-score">{{ item.overall_scores[0] }}</div>
                        <div class="total-score">{{ item.overall_scores[1] }}</div>
                    </div> -->
                    <div slot="game_scores" slot-scope="_, item1" style="display: flex; justify-content: center;">
                        <div class="competitor-info">
                            <div
                                style="display: flex; flex-direction: column;">
                                <div class="total-score">{{ item1.game_scores.overall_scores[0] }}</div>
                                <div class="total-score">{{ item1.game_scores.overall_scores[1] }}</div>
                            </div>
                            <div style="width: 2px; height: 50px; background: #0072BE;"></div>
                            <div style="display: flex; flex-direction: column; margin-left: 10px; ">
                                <div class="row-item" v-for="(item, index) in item1.game_scores.rally_scores" :key="index"
                                    style="width: 200px">
                                    <div class="score-item" :class="element.win ? 'win' : 'lose'"
                                        v-for="(element, index) in item" :key="index">
                                        {{ element.score }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a-table>
            </div>
        </div>
    </a-space>
</template>

<script>
import {getMatchResult, getTeamMatchesAll, getTeamPlayersAll} from "@/api";
import { defineComponent, ref } from 'vue';
import { message } from "ant-design-vue";
import { MatchDescription } from "@/utils/common"
import utils from '../../utils/cardIcon.js'

const value1 = 'medal_all';
const value2 = 'game_all';
const options1 = ref([
    {
        value: 'medal_all',
        label: '全部',
    },
    {
        value: 'gold',
        label: '金牌',
    },
    {
        value: 'silver',
        label: '银牌',
    },
    {
        value: 'bronze',
        label: '铜牌',
    },
]);

const options2 = ref([
    {
        value: 'game_all',
        label: '全部',
    },
    {
        value: 'win',
        label: '胜',
    },
    {
        value: 'lose',
        label: '负',
    },
]);

const columns = [
  {
    // title: 'index',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    slots: { title: 'indexTitle' },
    scopedSlots: { customRender: 'index' },
    width: 150
  },
    {
        // title: '比赛',
        dataIndex: 'match',
        key: 'match',
        align: 'center',
        slots: { title: 'matchTitle' },
        scopedSlots: { customRender: 'match' },
    },
    {
        // title: '时间',
        dataIndex: 'date',
        key: 'date',
        align: 'center',
        slots: { title: 'dateTitle' },
        scopedSlots: { customRender: 'date' },
        width: 200
    },
    {
        // title: '地点',
        dataIndex: 'location',
        key: 'location',
        align: 'center',
        slots: { title: 'locationTitle' },
        scopedSlots: { customRender: 'location' },
        width: 200
    },
    {
        // title: '名次',
        dataIndex: 'medal',
        key: 'medal',
        align: 'center',
        slots: { title: 'medalTitle' },
        scopedSlots: { customRender: 'medal' },
        width: 100
    },
    {
        // title: '最后一赛',
        dataIndex: 'last_match_level',
        key: 'last_match_level',
        align: 'center',
        slots: { title: 'levelTitle' },
        scopedSlots: { customRender: 'last_match_level' },
        width: 200
    },
    {
        // title: '参赛双方',
        dataIndex: 'competitors',
        key: 'competitors',
        align: 'center',
        slots: { title: 'competitorsTitle' },
        scopedSlots: { customRender: 'competitors' },
        width: 300
    },
    // {
    //     // title: '局比分',
    //     dataIndex: 'overall_scores',
    //     key: 'overall_scores',
    //     align: 'center',
    //     slots: { title: 'overallTitle' },
    //     scopedSlots: { customRender: 'overall' },
    // },
    {
        // title: '局回合比分',
        dataIndex: 'game_scores',
        key: 'game_scores',
        align: 'center',
        slots: { title: 'gameTitle' },
        scopedSlots: { customRender: 'game_scores' },
    },
];

const medal_rankings = { 'Gold': 4, 'Silver': 3, 'Bronze': 2, 'No-medal': 1 }

export default defineComponent({
    name: "MatchInfoTable",
    data() {
        return {
            columns: columns,
            default:require('@/assets/men_default_right.png'),
            data: [],
            displayed_data: null,
            value1: value1,
            value2: value2,
            options1: options1,
            options2: options2,
            focus: 0,
            medal_option: 'medal_all',
            game_option: 'game_all',
            order: 'dateDescending',
            player_info: null,
            player_partner_info: null,
            table_height: null,
            table_width: null
        };
    },
    props: {
        "args": {
            type: Object,
            default: null,
        }
    },
    computed: {

    },

    watch: {
        args: {
            handler(value) {
                console.log("args:", value)
                this.processData();
            }
        },
        immediate: true,
        deep: true,
    },
    // beforeMount() {
    //     this.getMatchList();
    // },
    mounted() {
        var elem = document.getElementById("matchInfoTable");
        this.table_height = elem.offsetHeight
        this.table_width - elem.offsetWidth * 0.85
        this.$store.commit('setLoading', true)
        this.getMatchListAll().then((allMatch) => {
            this.$store.commit('setMatchListAll', allMatch);
            this.getPlayerList().then((pdata => {
                // TODO save player data to this local store in vue
                // console.log(pdata.players)
                this.$store.commit('setPlayersInfo', pdata.players)
                this.processData().then(() => {
                    this.$store.commit('setLoading', false)
                })
            }))
        })
    },
    methods: {
        async getPlayerList() {
            // const response = await getTeamPlayersWithoutSelectCheck(this.$store.state.currentTeam)
            const response = await getTeamPlayersAll()
            if (response.status === 200) {
                return response.data
            }
        },
        async getMatchListAll() {
            const response = await getTeamMatchesAll()
            if (response.status === 200) {
                return response.data.matches.sort(utils.compareFnDate)
            }
        },

        async getMatch(startTime, endTime, team, type_single_double_mixed, targetPlayer, targetPlayerPartner) {
            const response = await getMatchResult(startTime, endTime, team, type_single_double_mixed, targetPlayer, targetPlayerPartner)
            if (response.status === 200 && response.data.success === true) {
                // console.log("match", response.data.data)
                return response.data.data
            } else {
                message.error('error')
                return []
            }
        },
        async processData() {
            this.data = null
            this.value1 = value1
            this.value2 = value2
            this.medal_option = 'medal_all'
            this.game_option = 'game_all'
            this.order = 'dateDescending'
            this.getMatch(this.$props.args.startTime, this.$props.args.endTime, this.$store.state.currentTeam, this.$props.args.type_single_double_mixed,
                this.$props.args.targetPlayer, this.$props.args.targetPlayerPartner).then(
                    (match_data) => {
                        this.player_info = this.$store.state.playersInfo[this.$props.args.targetPlayer]
                        this.player_partner_info = this.$props.args.targetPlayerPartner === "" ? null : this.$store.state.playersInfo[this.$props.args.targetPlayerPartner]
                        let newDataList = []
                        for (let i = 0; i < match_data.length; i++) {
                            let d = match_data[i]
                            let match_id = parseInt(d.match_id, 10)
                            // match_id = match_id <= 70 ? match_id - 1 : match_id - 40

                            const compInfo = this.$store.state.matchListAll.find(item => item.match_id == match_id)
                            // console.log('compInfo=',compInfo,match_id)
                            let date = compInfo.start_date.join('-') + ' ~ ' + compInfo.end_date.join('-')
                            let description = MatchDescription.find(item => item.key.includes(d.lastMatchLevel)) ? MatchDescription.find(item => item.key.includes(d.lastMatchLevel)).label : d.lastMatchLevel
                            let game_scores = d.eventResult.resultsGameScores.split(',')
                            let score1 = []
                            let score2 = []
                            for (let j = 0; j < game_scores.length; j++) {
                                let s1 = parseInt(game_scores[j].split('-')[0], 10)
                                let s2 = parseInt(game_scores[j].split('-')[1], 10)
                                score1.push({ "score": s1, "win": s1 >= s2 })
                                score2.push({ "score": s2, "win": s1 < s2 })
                            }
                            let country1 = d.eventResult.competitors[0].competitiorOrg
                            let country2 = d.eventResult.competitors[1].competitiorOrg
                            let name1 = d.eventResult.competitors[0].players[1].playerName ?
                                (d.eventResult.competitors[0].players.map(e => e.player_zh_name === "-1"||e.player_zh_name === "" ? e.playerName : e.player_zh_name).join(' & ')) :
                                (d.eventResult.competitors[0].players[0].player_zh_name === "-1"||d.eventResult.competitors[0].players[0].player_zh_name === "" ? d.eventResult.competitors[0].players[0].playerName : d.eventResult.competitors[0].players[0].player_zh_name)
                            let name2 = d.eventResult.competitors[1].players[1].playerName ?
                                (d.eventResult.competitors[1].players.map(e => e.player_zh_name === "-1"||e.player_zh_name === "" ? e.playerName : e.player_zh_name).join(' & ')) :
                                (d.eventResult.competitors[1].players[0].player_zh_name === "-1"||d.eventResult.competitors[1].players[0].player_zh_name === "" ? d.eventResult.competitors[1].players[0].playerName : d.eventResult.competitors[1].players[0].player_zh_name)
                            let is_inverted = false
                            if (d.eventResult.competitors[1].players[0].player_cn_id_in_db === this.$props.args.targetPlayer || d.eventResult.competitors[1].players[1].player_cn_id_in_db === this.$props.args.targetPlayer) {
                                is_inverted = true
                            }
                            let result = {
                                key: i,
                                match: d.eventResult.match_name,
                                date: date,
                                location: compInfo.location,
                                medal: d.medal,
                                last_match_level: description,
                                competitors: is_inverted ? [{ "country": country2, "name": name2 }, { "country": country1, "name": name1 }]
                                : [{ "country": country1, "name": name1 }, { "country": country2, "name": name2 }],
                                // overall_scores: d.eventResult.resultOverallScores.split('-'),
                                game_scores: is_inverted ? { 'rally_scores': [score2, score1], 'overall_scores': d.eventResult.resultOverallScores.split('-').reverse() }
                                : { 'rally_scores': [score1, score2], 'overall_scores': d.eventResult.resultOverallScores.split('-') }
                            }
                            newDataList.push(result)
                        }
                        this.data = newDataList
                        this.updateDisplayedData()
                        // console.log('displayed_data: ', this.displayed_data.length)
                        // sort by start date
                        // this.displayed_data = JSON.parse(JSON.stringify(this.data))
                        // this.dateAscending()
                        // console.log('data:', this.data)
                        // console.log('displayed data:', this.displayed_data)
                    }
                )
        },
        setRowClass(record, index) {

            return (index % 2 === 0) ? 'row-default1' : 'row-default2'
        },
        getCountryUrl(country) {
            return utils.getCountryIconUrl(country)
        },

        focus1() {
            this.focus = 1
        },
        focus2() {
            this.focus = 2
        },
        handleSelection(value) {
            // console.log("focus:", this.focus)
            // console.log(`selected ${value}`)
            if(this.focus === 1) {
                this.medal_option = value
            }
            else if(this.focus === 2) {
                this.game_option = value
            }
            // if (value === 'medal_all' || value === 'gold' || value === 'silver' || value === 'bronze') {
            //     this.medal_option = value
            // }
            // else if (value === 'game_all' || value === 'win' || value === 'lose') {
            //     this.game_option = value
            // }
            this.updateDisplayedData()
        },
        dateAscending() {
            console.log('date ascending')
            this.order = 'dateAscending'
            this.updateDisplayedData()
        },
        dateDescending() {
            console.log('date descending')
            this.order = 'dateDescending'
            this.updateDisplayedData()
        },
        medalAscending() {
            console.log('medal ascending')
            this.order = 'medalAscending'
            this.updateDisplayedData()
        },
        medalDescending() {
            console.log('medal descending')
            this.order = 'medalDescending'
            this.updateDisplayedData()
        },
        updateDisplayedData() {
            this.displayed_data = JSON.parse(JSON.stringify(this.data))
            let local_variable_displayed_data = this.displayed_data
            switch (this.order) {
                case 'dateAscending':
                    local_variable_displayed_data.sort((a, b) => {
                        let date1 = new Date(a.date.split(' ~ ')[0])
                        let date2 = new Date(b.date.split(' ~ ')[0])
                        return date1 - date2
                    })
                    break
                case 'dateDescending':
                    local_variable_displayed_data.sort((a, b) => {
                        let date1 = new Date(a.date.split(' ~ ')[0])
                        let date2 = new Date(b.date.split(' ~ ')[0])
                        return date2 - date1
                    })
                    break
                case 'medalAscending':
                    local_variable_displayed_data.sort((a, b) => {
                        return medal_rankings[a.medal] - medal_rankings[b.medal]
                    })
                    break
                case 'medalDescending':
                    local_variable_displayed_data.sort((a, b) => {
                        return medal_rankings[b.medal] - medal_rankings[a.medal]
                    })
                    break
                default:
                    console.log('Wrong order format!')
            }
            switch (this.medal_option) {
                case 'medal_all':
                    break
                case 'gold':
                    local_variable_displayed_data = local_variable_displayed_data.filter(item => item.medal === 'Gold');
                    break
                case 'silver':
                    local_variable_displayed_data = local_variable_displayed_data.filter(item => item.medal === 'Silver');
                    break
                case 'bronze':
                    local_variable_displayed_data = local_variable_displayed_data.filter(item => item.medal === 'Bronze');
                    break
            }
            switch (this.game_option) {
                case 'game_all':
                    break
                case 'win':
                    local_variable_displayed_data = local_variable_displayed_data.filter(item => item.game_scores.overall_scores[0] > item.game_scores.overall_scores[1]);
                    break
                case 'lose':
                    local_variable_displayed_data = local_variable_displayed_data.filter(item => item.game_scores.overall_scores[0] < item.game_scores.overall_scores[1]);
                    break
            }
            this.displayed_data = local_variable_displayed_data
        },
    }
});
</script>

<style lang="less" scoped>
.ant-table-thead {
    ::v-deep & tr>th {
        background-color: #00375b;
    }
}

/deep/ .row-default1 {
    background-color: #ecf6ff;
}

/deep/ .row-default2 {
    background-color: #d5e3ef;
}

/deep/ .icon {
    width: 45px;
    height: 45px;
    object-fit: cover;
    border-radius: 50%;
    margin: 0 6px;
    padding: 2px;
    object-position: top;
}

/deep/ .flag {
    width: 30px;
    height: 20px;
    margin: 2px 0;
    vertical-align: top;
    border: rgb(0 0 0 / 25%) 1px solid;
    margin-right: 10px;
}

/deep/ .medal {
    width: 30px;
    height: 30px;
}

/deep/ .member-name {
    font-family: 'Lantinghei SC';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    margin-top: 20px;
    line-height: 28px;
    letter-spacing: -0.015em;
    color: black;
}

/deep/ .medal_and_win {
    font-family: 'Lantinghei SC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.015em;
    color: black;
    margin-left: 20px;
}

/deep/ .table-text {
    font-size: 20px;
}

/deep/ .competitor-info {
    display: flex;
    flex-flow: row;
    // justify-content: space-between;
    align-items: center;
    padding: 8px;
}

/deep/ .total-score {
    font-family: 'DIN Alternate';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    padding: 0 14px;
    text-align: center;
    letter-spacing: -0.015em;
    color: #0072BE;
}

/deep/ .row-item {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
}

/deep/ .score-item {
    font-family: 'DIN Alternate';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.015em;
    width: 30px;
    margin-right: 6px;

    /deep/ &.win {
        color: #0072BE;
    }

    /deep/ &.lose {
        color: #8E8E8E;
    }
}

/deep/ .selector {
    float: left;
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 10px;
}

/deep/ .tableHolder {
    padding-top: 2vh;
    margin-left: 30px;
    margin-right: 30px;
}</style>
